export const VipButtonText = Object.freeze({
  VIP: '9折续费VIP，立减1176元',
  NORMAL: '会员低至8.5元/日，立即开通'
})